// LONGEV CIRCLE — mock data
import {
  Apple,
  Dumbbell,
  Waves,
  Stethoscope,
  Flame,
  Sparkles,
} from "lucide-react";

export const BRAND = {
  name: "LONGEV CIRCLE",
  location: "Basel, Switzerland",
  tagline: "Total Body Transformation, engineered for your lifetime.",
  instagram: "https://www.instagram.com/swisssculpt_by_arvind",
  instagramHandle: "@swisssculpt_by_arvind",
  email: "hello@longevcircle.com",
};

export const PILLARS = [
  {
    id: "nutrition",
    number: "01",
    name: "Nutrition Counselling",
    short: "Nutrition",
    icon: Apple,
    description:
      "Swap regular groceries for healthy alternatives. Shop smart and make nutrition work for your budget and lifestyle.",
    image:
      "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    color: "#5C7A4F",
  },
  {
    id: "strength",
    number: "02",
    name: "Strength & Mobility",
    short: "Strength",
    icon: Dumbbell,
    description:
      "Gym, calisthenics, and high-intensity mobility work — built to move better as you age.",
    image:
      "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    color: "#3E4A3A",
  },
  {
    id: "endurance",
    number: "03",
    name: "Endurance",
    short: "Endurance",
    icon: Waves,
    description:
      "Specialized swimming, cardio conditioning, outdoor walks and Alpine hikes.",
    image:
      "https://images.unsplash.com/photo-1558705671-c2cf0a1cdd74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    color: "#4A6B7A",
  },
  {
    id: "medical",
    number: "04",
    name: "Medical Counselling",
    short: "Medical",
    icon: Stethoscope,
    description:
      "Science-backed health and metric tracking. Bloodwork, biomarker review, longevity guidance.",
    image:
      "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    color: "#7A5C4F",
  },
  {
    id: "wellness",
    number: "05",
    name: "Wellness",
    short: "Wellness",
    icon: Flame,
    description:
      "Dedicated recovery (Sauna, Steam, Ice) and massage to prevent burnout.",
    image:
      "https://images.unsplash.com/photo-1717356495389-6ab1e5ff9d84?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    color: "#8C6A3E",
  },
  {
    id: "longevity",
    number: "06",
    name: "Longevity & Grooming",
    short: "Longevity",
    icon: Sparkles,
    description:
      "Look younger while building muscle. Skincare, grooming, biological age strategies.",
    image:
      "https://images.pexels.com/photos/6663585/pexels-photo-6663585.jpeg",
    color: "#5A5A6B",
  },
];

// Individual services available a-la-carte across pillars
export const SERVICES = [
  // Nutrition
  { id: "n1", pillarId: "nutrition", name: "1:1 Nutrition Consult (60 min)", description: "Personalized food strategy with your coach.", price: 120, unit: "session" },
  { id: "n2", pillarId: "nutrition", name: "Grocery Store Walkthrough", description: "Smart shopping at your local store.", price: 180, unit: "session" },
  { id: "n3", pillarId: "nutrition", name: "Weekly Meal Plan", description: "Custom meal plan with shopping list.", price: 60, unit: "week" },
  { id: "n4", pillarId: "nutrition", name: "Macro & Calorie Coaching", description: "Ongoing macro adjustments and check-ins.", price: 90, unit: "month" },

  // Strength
  { id: "s1", pillarId: "strength", name: "1:1 Personal Training (60 min)", description: "Hands-on coaching at the gym.", price: 110, unit: "session" },
  { id: "s2", pillarId: "strength", name: "Calisthenics Block (4 weeks)", description: "Bodyweight strength progression.", price: 280, unit: "block" },
  { id: "s3", pillarId: "strength", name: "Mobility Intensive (45 min)", description: "Joint health, range of motion.", price: 85, unit: "session" },
  { id: "s4", pillarId: "strength", name: "Custom Training Program", description: "12-week progressive plan.", price: 240, unit: "program" },

  // Endurance
  { id: "e1", pillarId: "endurance", name: "Swim Technique Coaching (60 min)", description: "Pool-based stroke refinement.", price: 130, unit: "session" },
  { id: "e2", pillarId: "endurance", name: "Cardio Conditioning Block", description: "VO2 max & zone-2 work.", price: 220, unit: "block" },
  { id: "e3", pillarId: "endurance", name: "Guided Alpine Hike (half-day)", description: "Outdoor endurance with coach.", price: 260, unit: "outing" },
  { id: "e4", pillarId: "endurance", name: "Run Form Analysis", description: "Gait & cadence review.", price: 95, unit: "session" },

  // Medical
  { id: "m1", pillarId: "medical", name: "Comprehensive Bloodwork Panel", description: "40+ biomarkers analyzed.", price: 320, unit: "test" },
  { id: "m2", pillarId: "medical", name: "Physician Consult (45 min)", description: "Discuss labs and protocols.", price: 240, unit: "consult" },
  { id: "m3", pillarId: "medical", name: "Continuous Glucose Monitor (2 wk)", description: "CGM device + interpretation.", price: 195, unit: "cycle" },
  { id: "m4", pillarId: "medical", name: "DEXA Body Composition Scan", description: "Bone density & body composition.", price: 165, unit: "scan" },

  // Wellness
  { id: "w1", pillarId: "wellness", name: "Sauna + Steam Session (90 min)", description: "Heat protocol at our partner spa.", price: 75, unit: "session" },
  { id: "w2", pillarId: "wellness", name: "Ice Bath Protocol", description: "Guided cold exposure session.", price: 65, unit: "session" },
  { id: "w3", pillarId: "wellness", name: "Sports Massage (60 min)", description: "Deep tissue with licensed therapist.", price: 140, unit: "session" },
  { id: "w4", pillarId: "wellness", name: "Recovery Day Package", description: "Sauna + ice + massage combo.", price: 230, unit: "day" },

  // Longevity & Grooming
  { id: "l1", pillarId: "longevity", name: "Skincare Protocol Setup", description: "Personalized routine + product list.", price: 110, unit: "consult" },
  { id: "l2", pillarId: "longevity", name: "Biological Age Assessment", description: "Epigenetic test + review.", price: 380, unit: "test" },
  { id: "l3", pillarId: "longevity", name: "Sleep Optimization Plan", description: "4-week sleep coaching.", price: 195, unit: "plan" },
  { id: "l4", pillarId: "longevity", name: "Grooming Style Consult", description: "Hair, beard, and presentation.", price: 130, unit: "consult" },
];

export const STANDARD_PACKAGES = [
  {
    id: "essential",
    tier: "01",
    name: "Essential",
    tagline: "Start your transformation.",
    description:
      "The foundation for anyone beginning their longevity journey. Two pillars, weekly touchpoints.",
    price: 480,
    period: "month",
    bestFor: "Beginners",
    accent: false,
    includes: [
      "Nutrition consult + weekly meal plan",
      "4× personal training sessions / month",
      "Monthly progress review",
      "WhatsApp coach access",
    ],
    pillars: ["nutrition", "strength"],
  },
  {
    id: "performance",
    tier: "02",
    name: "Performance",
    tagline: "Most popular — built for serious results.",
    description:
      "Four pillars in harmony. Designed for working professionals who want measurable change.",
    price: 920,
    period: "month",
    bestFor: "Most members",
    accent: true,
    includes: [
      "Everything in Essential",
      "Endurance coaching + 1 outdoor session/month",
      "Bloodwork panel + physician review (quarterly)",
      "2× recovery sessions (sauna/massage)",
      "Quarterly Body Composition",
    ],
    pillars: ["nutrition", "strength", "endurance", "medical"],
  },
  {
    id: "elite",
    tier: "03",
    name: "Elite Longevity",
    tagline: "All six pillars. White-glove care.",
    description:
      "Full ecosystem coverage. For those serious about reversing biological age.",
    price: 1640,
    period: "month",
    bestFor: "Executives & athletes",
    accent: false,
    includes: [
      "Everything in Performance",
      "Weekly recovery (sauna, ice, massage)",
      "Biological age test (quarterly)",
      "Skincare & grooming protocol",
      "Concierge scheduling",
      "Guided Alpine outings (monthly)",
    ],
    pillars: ["nutrition", "strength", "endurance", "medical", "wellness", "longevity"],
  },
];

export const TESTIMONIALS = [
  {
    name: "Aradhya",
    role: "IT Business Lead",
    quote:
      "I came in with a diabetic condition, tired and HbA1c touching 7.5. Within 4 weeks of enrollment my reading is now 5.5 — my doctor was shocked and said 'whatever you're doing, keep doing it — it's working.'",
  },
  {
    name: "Member",
    role: "Executive, Basel",
    quote:
      "I get very focused attention — and it does not end with the training session. From nutrition counselling to scientific principles and chat support, they are making a real lifestyle change with me. I've also become part of a community where similar folks motivate each other and share our goals and achievements. I've lost a few kilos and feel younger.",
  },
  {
    name: "Member",
    role: "Woman, 40+",
    quote:
      "I'm a 40+ woman with no prior training experience. I always felt low in energy. Two months in and I can really feel the difference in my strength, mobility, and body-mind coordination.",
  },
];

export const FOUNDER = {
  name: "Coach Arvind Arora",
  role: "Founder & Head Coach",
  image:
    "/brand/founder.jpg",
  bio:
    "Longevity coach based in Basel, guiding executives, athletes and high-performers through holistic Total Body Transformation programs across all six pillars.",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1728532483490-708f6562b738?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

// ---------- Longevity Assessment ----------

// Goals list. Some are gender-specific.
// applies: "all" | "pink" (female only) | "blue" (male only)
export const ASSESSMENT_GOALS = [
  { id: "glp1", label: "I'm on GLP-1 and want to manage weight loss effectively.", applies: "all" },
  { id: "diabetes", label: "I'm diabetic/prediabetic — improve metabolic health with training & nutrition.", applies: "all" },
  { id: "menopause", label: "I'm menopausal/perimenopausal, aiming to stay fit and energetic.", applies: "pink" },
  { id: "muscle_aging", label: "I'm aging and my muscles are weak — I want to build strength.", applies: "all" },
  { id: "leaner", label: "Reduce body fat and build a leaner, healthier physique.", applies: "all" },
  { id: "muscle_def", label: "Build stronger, more defined muscles and improve body composition.", applies: "all" },
  { id: "fit_metabolic", label: "Improve physical fitness while managing my metabolic health.", applies: "all" },
  { id: "family_active", label: "Increase strength, energy and mobility to stay active with my family.", applies: "all" },
  { id: "cardio", label: "Improve cardiovascular fitness and endurance.", applies: "all" },
  { id: "functional", label: "Build functional strength, flexibility and mobility.", applies: "all" },
  { id: "sleep", label: "Sleep better and wake up feeling energized every day.", applies: "all" },
  { id: "confidence", label: "Look and feel more confident in the clothes I wear.", applies: "all" },
  { id: "stress", label: "Reduce stress and improve daily resilience.", applies: "all" },
  { id: "energy", label: "Improve energy levels throughout the day.", applies: "all" },
  { id: "nutrition_habits", label: "Improve nutrition and develop healthier eating habits.", applies: "all" },
  { id: "overall", label: "Improve my overall health and long-term wellbeing.", applies: "all" },
];

export const CONDITIONS = [
  "Hypertension",
  "High cholesterol",
  "Diabetes",
  "Prediabetes",
  "Cardiovascular disease",
  "Stroke / TIA",
  "Kidney disease",
  "Liver disease",
  "Thyroid disease",
  "Cancer",
  "Sleep apnea",
  "Asthma / COPD",
  "Osteoporosis",
  "Arthritis",
  "Depression",
  "Anxiety",
  "Herniated disc / Sciatica",
];

export const FAMILY_CARDIO = ["Heart attack", "Stroke", "Sudden cardiac death", "Hypertension"];
export const FAMILY_NEURO = ["Dementia / Alzheimer's", "Parkinson's"];

export const NUTRITION_FREQ_ITEMS = [
  "Vegetables",
  "Fruit",
  "Legumes",
  "Whole grains",
  "Nuts / seeds",
  "Fish",
  "Processed meat",
  "Red meat",
  "Sugary drinks",
  "Ultra-processed foods",
];

export const FREQ_OPTIONS = ["Rarely", "1–2×/week", "3–4×/week", "5–6×/week", "Daily", "Multiple/day"];

export const SLEEP_DURATION = ["<5h", "5–6h", "6–7h", "7–8h", "8–9h", ">9h"];

export const TIME_BUCKETS = ["<2 hrs", "2–4 hrs", "4–6 hrs", "6–10 hrs", "10+ hrs"];

export const FAQS = [
  {
    q: "How does LONGEV CIRCLE differ from a regular gym or trainer?",
    a: "We integrate six pillars — nutrition, strength, endurance, medical, wellness and longevity — into one coordinated plan. Most gyms address one. We coordinate them all.",
  },
  {
    q: "Can I build my own package?",
    a: "Yes. Use the 'Build Your Package' tool to mix individual services across all six pillars. We'll review your selection and send a tailored quote within 24 hours.",
  },
  {
    q: "Where do sessions take place?",
    a: "Primarily across Basel — our partner gym, pool, spa and outdoor locations. Some services (calls, planning) are remote.",
  },
  {
    q: "Is there a minimum commitment?",
    a: "Standard packages are month-to-month with no long lock-in. Custom packages are quoted per project — no commitment required.",
  },
  {
    q: "How does pricing work?",
    a: "Custom packages are quoted based on the services you select. Book a free 1:1 call to discuss options.",
  },
];
